module.exports = __webpack_public_path__ + "static/media/LetterHead.357ac9de.jpeg";